import { CSSTransition, TransitionGroup } from "react-transition-group";
import { ItemNotFoundInfo } from "../../QuickOrder/messageInfo/itemNotFoundInfo";
import { SearchResultContainer } from "./searchResultContainer";
import { Fragment, useEffect, useRef, useState } from "react";
import $ from "jquery";
import { AddToCartInfoAlert } from "../../../Layout/Common/alert/addToCartInfoAlert";
export const ResultSection = ({ searchNoResult, searchResult, productCode }) => {
  const [result, setResult] = useState(null);
  const successRef = useRef();
  const infoRef = useRef();
  useEffect(() => {
    if (searchResult) {
      setResult(searchResult);
    } else setResult(null);
    if (searchNoResult) {
      infoRef.current.showAlert("ITEM_ERROR", { sku: productCode });
    }
  }, [searchNoResult, searchResult]);

  const handleSuccess = () => {
    setResult(null);
    if (infoRef.current) infoRef.current.showSuccess();
  };

  return (
    <Fragment>
      <AddToCartInfoAlert ref={infoRef} />
      <TransitionGroup>
        {result && (
          <CSSTransition key="result" timeout={300} classNames="fade" unmountOnExit>
            <SearchResultContainer item={result} onSuccess={handleSuccess} />
          </CSSTransition>
        )}
      </TransitionGroup>
    </Fragment>
  );
};
